import React from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import { Div, Popover } from "components/Base";
import { actions } from "../../model";

import CSSModules from "react-css-modules";
import css from "../styles.scss";
import { Link } from "react-router";
import Tooltip from "ui-kit/Tooltip";

import Avatar from "components/Atoms/Avatar";

import { eventDetails as getEventDetails } from "redux/modules/event/selectors";
import { getIsUserOnline, user as getUser } from "redux/modules/user/selectors";
import { canEventUserDo } from "redux/modules/permissions/user-permission-profile/selectors";

import * as STANDARD_MODULE_IDS from "@sessionboard/sessionboard-value-types/src/constants/standard-modules";

import {
  getEventInitial,
  getLogoImageUrl,
  getEventDates,
  getEventVenue,
  getShowPublishButton
} from "../../selectors";

export const HeaderNavSeparator = ({}) => {
  return (
    <div
      style={{
        marginRight: "20px",
        width: "1px"
      }}
    />
  );
};

export const HeaderNavHelp = ({}) => {
  return (
    <Popover
      anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
      wrapperProps={{ style: { position: "relative", boxShadow: 0 } }}
      PaperProps={{
        style: {
          boxShadow: "none",
          marginTop: "5px"
        }
      }}
      Label={({ onClick }) => (
        <Tooltip tooltip="Help">
          <div className={css.helpIcon} onClick={onClick}>
            <i className="material-icons">help</i>
          </div>
        </Tooltip>
      )}
    >
      {({ closePopover }) => (
        <div className={css.helpIconMenu}>
          <div
            className={css.helpIconMenuItem}
            onClick={() => {
              if (window.HubSpotConversations) {
                window.HubSpotConversations.widget.load({ widgetOpen: true });
                window.HubSpotConversations.widget.open();
              }

              closePopover();
            }}
          >
            <div className={css.helpIconMenuItemIcon}>
              <i className="material-icons-outlined">question_answer</i>
            </div>
            <div className={css.helpIconMenuItemSeparator} />
            <div className={css.helpIconMenuItemLabel}>Message support</div>
            <div className={css.helpIconMenuItemArrow}>
              <i className="material-icons">east</i>
            </div>
          </div>

          {/**  */}

          <div
            className={css.helpIconMenuItem}
            onClick={() => {
              window.open(
                "https://learn.sessionboard.com/en/knowledge-base",
                "_blank"
              );
              closePopover();
            }}
          >
            <div className={css.helpIconMenuItemIcon}>
              <i className="material-icons-outlined">help</i>
            </div>
            <div className={css.helpIconMenuItemSeparator} />
            <div className={css.helpIconMenuItemLabel}>
              Visit our help center
            </div>
            <div className={css.helpIconMenuItemArrow}>
              <i className="material-icons">east</i>
            </div>
          </div>

          {/**  */}

          <div
            className={css.helpIconMenuItem}
            onClick={() => {
              window.open(
                "https://learn.sessionboard.com/en/knowledge-base/product-release-notes",
                "_blank"
              );
              closePopover();
            }}
          >
            <div className={css.helpIconMenuItemIcon}>
              <i className="material-icons-outlined">notifications</i>
            </div>
            <div className={css.helpIconMenuItemSeparator} />
            <div className={css.helpIconMenuItemLabel}>See what's new</div>
            <div className={css.helpIconMenuItemArrow}>
              <i className="material-icons">east</i>
            </div>
          </div>
        </div>
      )}
    </Popover>
  );
};

export const HeaderNavAvatar = ({ user, isOnline }) => {
  return (
    <Popover
      anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
      wrapperProps={{ style: { position: "relative", boxShadow: 0 } }}
      PaperProps={{
        style: {
          boxShadow: "none",
          marginTop: "5px"
        }
      }}
      Label={({ onClick }) => (
        <Tooltip tooltip="My Account">
          <div className={css.avatarWrapper} onClick={onClick}>
            <Avatar
              size={26}
              style={{
                height: 26,
                width: 26,
                borderRadius: 5
              }}
              userId={user.id}
              imageUrl={user.photo_url}
              firstName={user.fname}
              lastName={user.lname}
              showOnline={isOnline}
            />
            <i className="material-icons-outlined">keyboard_arrow_down</i>
          </div>
        </Tooltip>
      )}
    >
      {() => (
        <div className={css.helpIconMenu}>
          <div
            className={css.helpIconMenuItem}
            onClick={() => {
              window.location = "/account/settings";
            }}
          >
            <div className={css.helpIconMenuItemIcon}>
              <i className="material-icons-outlined">settings</i>
            </div>
            <div className={css.helpIconMenuItemSeparator} />
            <div className={css.helpIconMenuItemLabel}>Account Settings</div>
            <div className={css.helpIconMenuItemArrow}>
              <i className="material-icons">east</i>
            </div>
          </div>

          {/**  */}

          <div
            className={css.helpIconMenuItem}
            onClick={() => {
              window.location = "/logout";
            }}
          >
            <div className={css.helpIconMenuItemIcon}>
              <i className="material-icons-outlined">logout</i>
            </div>
            <div className={css.helpIconMenuItemSeparator} />
            <div className={css.helpIconMenuItemLabel}>Log out</div>
            <div className={css.helpIconMenuItemArrow}>
              <i className="material-icons">east</i>
            </div>
          </div>
        </div>
      )}
    </Popover>
  );
};

const decorate = R.compose(
  connect(
    (state, props) => ({
      eventDetails: getEventDetails(state, props),
      user: getUser(state, props),
      isOnline: getIsUserOnline(state, props),
      eventInitial: getEventInitial(state),
      logoImageUrl: getLogoImageUrl(state),
      eventDates: getEventDates(state),
      venue: getEventVenue(state),
      showPublishButton: getShowPublishButton(state),
      canUpdateSettings: canEventUserDo(state)(
        `${STANDARD_MODULE_IDS.settings.id}_update`
      )
    }),
    {
      onToggleCollapsed: actions.toggleCollapse,
      showLogoFilepicker: actions.showLogoFilepicker,
      publishEvent: actions.publishEvent
    }
  ),
  CSSModules(css)
);

const Header = ({
  eventDetails,
  onToggleCollapsed,
  eventInitial,
  logoImageUrl,
  showLogoFilepicker,
  eventDates,
  canUpdateSettings,
  user,
  isOnline
}) => {
  return (
    <div className={css.header}>
      <div className={css.subHeaderLeft}>
        <div className={css.menuIcon} onClick={onToggleCollapsed}>
          <span className="material-icons-outlined">menu</span>
        </div>

        <Tooltip tooltip="View all my organizations" placement="bottom">
          <Link
            to="/home"
            style={{
              display: "flex"
            }}
          >
            <img
              src="https://d2ams66j58uyd5.cloudfront.net/images/sessionboard-square-logo.png"
              height={30}
            />
          </Link>
        </Tooltip>
        <Div display="row.flex-start.center" ml={2}>
          <Div fs={5} fw={4} color="black" mr={2}>
            +
          </Div>

          {logoImageUrl ? (
            <Div
              width={30}
              height={30}
              bra={1}
              bg="gray1"
              display="row.center.center"
              mr={2}
              style={{
                backgroundImage: `url(${logoImageUrl})`,
                backgroundSize: "cover",
                backgroundPosition: "center center",
                border: "1px solid #eee"
              }}
            />
          ) : canUpdateSettings ? (
            <Tooltip tooltip="Upload event logo" placement="bottom">
              <Div
                width={30}
                height={30}
                bra={1}
                bg={{
                  default: "gray1",
                  hover: "gray2"
                }}
                display="row.center.center"
                mr={2}
                onClick={showLogoFilepicker}
              >
                <Div fw={3} color="#ccc" fs={3}>
                  {eventInitial}
                </Div>
              </Div>
            </Tooltip>
          ) : (
            <Div
              width={30}
              height={30}
              bra={1}
              bg={{
                default: "gray1",
                hover: "gray2"
              }}
              display="row.center.center"
              mr={2}
            >
              <Div fw={3} color="#ccc" fs={3}>
                {eventInitial}
              </Div>
            </Div>
          )}
          <Div display="column">
            <Div
              fs={3}
              fw={4}
              color="black"
              style={{
                fontSize: "18px"
              }}
            >
              {eventDetails.name}
            </Div>
            {eventDates ? (
              <div className={css.eventMeta}>
                {eventDates ? (
                  <span className="material-icons-outlined">
                    calendar_today
                  </span>
                ) : null}
                {eventDates}
              </div>
            ) : null}
          </Div>
        </Div>
      </div>

      <div className={css.subHeaderRight}>
        <Tooltip tooltip="View my portal">
          <Link
            target="_blank"
            to={`/portals/${eventDetails.slug}/${eventDetails.uuid}`}
          >
            <Div
              color="black"
              fw={3}
              style={{
                fontSize: "18px"
              }}
            >
              My Portal
            </Div>
          </Link>
        </Tooltip>

        <HeaderNavSeparator />

        <HeaderNavHelp />

        <HeaderNavSeparator />

        <HeaderNavAvatar user={user} isOnline={isOnline} />
      </div>
    </div>
  );
};

export default decorate(Header);
